module.exports = __webpack_public_path__ + "img/DerSong.d36a0eb4.jpg";